export const jobItemOutput = (payload) => {
  const { data, locale } = payload

  return {
    id: '',
    providerId: data.id,
    title: data.title,
    locale: locale.slice(0, 2),
    isInternal: false,
    area: '',
    office: data.location.name || '',
    description: data.content,
    externalLink: data.absolute_url,
  }
}
